import { FC } from 'react';

import { InvoicingPdf } from '__generated__/GQL';
import mail from 'assets/brand/mail.png';
import { SupportedLanguages } from 'common/locale';
import Button from 'components/_core/Button';
import SunshineModal from 'components/_core/SunshineModal';
import Text from 'components/_core/Text';
import { logEvent } from 'features/Analytics/analytics';
import { SendingOptionsEnum } from 'features/Work/types';
import { downloadPdf } from 'features/Work/utils';

import { useQuoteModals } from '../..';
import locales from './locales';

export interface ResendByMyselfModalProps {
  pdfLang: SupportedLanguages;
  quoteId: string;
  pdf: InvoicingPdf | null;
}

const ResendByMyselfModal: FC<ResendByMyselfModalProps> = ({
  pdf,
  pdfLang,
  quoteId,
}) => {
  const { hideModal } = useQuoteModals();

  const onDownloadPdf = () => {
    downloadPdf({ lang: pdfLang, pdf });

    logEvent({
      name: 'Quote Resent',
      properties: {
        from: 'ResendQuoteModal',
        lang: pdfLang,
        method: SendingOptionsEnum.downloadPdf,
        quoteId,
      },
    });

    hideModal();
  };

  return (
    <SunshineModal isOpen onClose={hideModal}>
      <SunshineModal.Header />

      <SunshineModal.Body>
        <SunshineModal.Body.Image src={mail} />
        <SunshineModal.Title>{locales.title}</SunshineModal.Title>
        <Text>{locales.description}</Text>
      </SunshineModal.Body>

      <SunshineModal.Footer>
        <Button onClick={hideModal} variant="inline-secondary">
          {locales.cancel}
        </Button>

        <Button onClick={onDownloadPdf}>{locales.downloadPdf}</Button>
      </SunshineModal.Footer>
    </SunshineModal>
  );
};

export default ResendByMyselfModal;
